import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

function* categoryListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.CATEGORY_LIST, payload);
    if (response.status == 200) {
      yield put(ACTION.categoryList_Success(response.data));
    } else {
      yield put(ACTION.categoryList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.categoryList_Fail(response.data.error));
  }
}
function* EditCategorysaga({ payload, callBack }) {
  try {
    const response = yield call(API.EDIT_MANAGE_CATEGORY, payload);
    if (response.status == 200) {
      yield put(ACTION.editCategory_Success(response.data));
    } else {
      yield put(ACTION.editCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.editCategory_Fail(response.data.error));
  }
}
function* updateCategorySaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_CATEGORY, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateCategory_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateCategory_Fail(response.data.error));
  }
}
function* addCategorySaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_CATEGORY, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.addCategory_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.addCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addCategory_Fail(response.data.error));
  }
}
function* deleteCategorySaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_CATEGORY, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteCategory_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.deleteCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteCategory_Fail(response.data.error));
  }
}

function* CategorySaga() {
  yield takeEvery(CONST.CATEGORY_LIST, categoryListSaga);
  yield takeEvery(CONST.EDIT_CATEGORY, EditCategorysaga);
  yield takeEvery(CONST.UPDATE_CATEGORY, updateCategorySaga);
  yield takeEvery(CONST.ADD_CATEGORY, addCategorySaga);
  yield takeEvery(CONST.DELETE_CATEGORY, deleteCategorySaga);
}

export default CategorySaga;
